import { render, staticRenderFns } from "./AccountsOverview.vue?vue&type=template&id=5de335f0&scoped=true&"
import script from "./AccountsOverview.vue?vue&type=script&lang=js&"
export * from "./AccountsOverview.vue?vue&type=script&lang=js&"
import style0 from "./AccountsOverview.vue?vue&type=style&index=0&id=5de335f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de335f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VTextField})
